import { HttpResponse, delay, http } from 'msw';

import { initPendo } from '../../util/pendo';
import {
	dashboardFeedbackForm,
	dashboardFeedbacks,
	feedbackRequest,
	feedbackSummary,
	feedbacks,
	forms,
	jobDescription,
	noSummary,
	pendo,
	people,
	recruitment,
	resumeLink,
	submitFeedback,
} from './mockData';
import sampleFile from './mockData/sample.pdf';

const {
	feedbackApi: { baseUrl },
	mockDelay,
} = global.config;

export const pdfResponse = async (samplePdf) => {
	const samplePdfBuffer = await fetch(samplePdf).then((res) => res.arrayBuffer());

	return new HttpResponse(samplePdfBuffer, {
		headers: {
			'Content-Length': samplePdfBuffer.byteLength.toString(),
			'Content-Type': 'application/pdf',
		},
	});
};

const handlers = [
	http.get(encodeURIComponent('/resume-link'), () => pdfResponse(sampleFile)),
	http.get('/resume-link', () => pdfResponse(sampleFile)),
	http.get(`${baseUrl}/get-user-info`, () =>
		HttpResponse.json({ todos: ['Server Todo #1', 'Server Todo #2'] }),
	),

	http.get(`${baseUrl}/proxy/feedback/feedback-requests`, async () => {
		await delay(mockDelay);

		return HttpResponse.json(feedbacks);
	}),

	http.post(`${baseUrl}/proxy/feedback/feedback-requests`, async () => {
		await delay(mockDelay);

		return HttpResponse.json(feedbackRequest);
	}),

	http.post(`${baseUrl}/proxy/feedback/feedback-cancel`, async () => {
		await delay(mockDelay);

		// void method
		return HttpResponse.json({});
	}),

	http.get(`${baseUrl}/proxy/feedback/forms`, async () => {
		await delay(mockDelay);

		return HttpResponse.json(forms);
	}),

	http.post(`${baseUrl}/proxy/feedback/search-people`, () => HttpResponse.json(people)),

	http.get(`${baseUrl}/proxy/feedback/recruitments/1`, () => HttpResponse.json(recruitment)),

	http.get(`${baseUrl}/proxy/feedback/analytic/info`, () => HttpResponse.json(initPendo(pendo))),

	http.get(`${baseUrl}/proxy/feedback/feedback-requests/:id/form`, async ({ params }) => {
		await delay(mockDelay);

		const { id } = params;

		if (id in dashboardFeedbackForm) {
			return HttpResponse.json(dashboardFeedbackForm[id]);
		}

		return HttpResponse.json(dashboardFeedbackForm['fbr-1']);
	}),

	http.post(`${baseUrl}/proxy/feedback/feedback-requests/:id/reminder`, async () => {
		await delay(mockDelay);

		return HttpResponse.json({});
	}),

	http.get(`${baseUrl}/proxy/feedback/interviewer-feedback-requests`, async () => {
		await delay(mockDelay);

		return HttpResponse.json(dashboardFeedbacks);
	}),

	http.post(`${baseUrl}/proxy/feedback/feedback-submit`, async () => {
		await delay(mockDelay);

		return HttpResponse.json(submitFeedback);
	}),

	http.get(`${baseUrl}/proxy/feedback/feedbacks/submittal/1135/form`, async () => {
		await delay(mockDelay);

		return HttpResponse.json(noSummary.noFeedbacks);
	}),

	http.get(`${baseUrl}/proxy/feedback/feedbacks/submittal/4500/form`, async () => {
		await delay(mockDelay);

		return HttpResponse.json(noSummary.disableSummary);
	}),
	http.get(`${baseUrl}/proxy/feedback/feedbacks/submittal/:submittalId/form`, async () => {
		await delay(mockDelay);

		return HttpResponse.json(feedbackSummary);
	}),

	http.get(
		`${baseUrl}/proxy/feedback/resume-link/:intervieweeId/customer/:customerId`,
		async () => {
			await delay(mockDelay);

			return HttpResponse.json(resumeLink);
		},
	),

	http.get(`${baseUrl}/proxy/feedback/job-description/:jobId/customer/:customerId`, async () => {
		await delay(mockDelay);

		return HttpResponse.json(jobDescription);
	}),
];

export { handlers };
